import { render, staticRenderFns } from "./ScreenSeriada.vue?vue&type=template&id=b1f9859c&scoped=true&"
import script from "./ScreenSeriada.vue?vue&type=script&lang=js&"
export * from "./ScreenSeriada.vue?vue&type=script&lang=js&"
import style0 from "./ScreenSeriada.vue?vue&type=style&index=0&id=b1f9859c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f9859c",
  null
  
)

export default component.exports